import * as React from "react";
import Cookies from "../Components/Cookies";
import Axios from "../Components/Axios";

class Exit extends React.Component {

    constructor(props) {
        super(props);
        Axios
            .get('/api/exit/' + Cookies.getSession())
            .then(() => {
                Cookies.deleteSession();
                this.props.history.push('/');
            });
    }

    render() {
        return <></>;
    }
}

export default Exit;
